import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { toast } from "react-toastify";
import { POINTS_SYSTEM_LIST, POINTS_SYSTEM_UPDATE } from "../../routes/routes";
import { POINTS_SYSTEM_UPDATED } from "../../constant/constant";
import Loader from "../../components/common/Loader";
import StickyTable from "../../components/common/StickyTable";
import { NoDataFound } from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";

const PointsSystem = () => {
  const { hasPermission } = usePermission();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [error, setError] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(false);

  const fetchList = () => {
    setLoading(true);
    axios
      .get(POINTS_SYSTEM_LIST)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data || []);
        }
      })
      .catch((err) => {
        console.error("Error fetching points system:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchList();
  }, []);

  const openEditModal = (item) => {
    setError("");
    setEditData({
      id: item.id,
      action: item.action,
      points: item.points,
    });
    setEditModal(true);
  };

  const updatePoints = () => {
    if (editData.points === "" || editData.points === null || editData.points === undefined) {
      setError("Points is required");
      return;
    }
    if (isNaN(Number(editData.points)) || Number(editData.points) < 0) {
      setError("Points must be a valid number");
      return;
    }

    setBtnDisabled(true);
    axios
      .put(POINTS_SYSTEM_UPDATE + editData.id, { points: editData.points })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(POINTS_SYSTEM_UPDATED);
          setEditModal(false);
          setData((prevData) =>
            prevData.map((item) =>
              item.id === editData.id
                ? { ...item, points: Number(editData.points) }
                : item
            )
          );
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          const apiError = err.response.data.error;
          setError(apiError?.points?.[0] || err.response.data.msg);
          toast.error(err.response.data.msg);
        } else {
          toast.error(err.response?.data?.msg || "Something went wrong");
        }
      })
      .finally(() => {
        setBtnDisabled(false);
      });
  };

  const popover = (
    <Popover
      id="popover-points-info"
      style={{
        border: "2px solid #696cff",
        borderRadius: "0.375rem",
        boxShadow: "0 0.25rem 1rem rgba(105, 108, 255, 0.25)",
        backgroundColor: "#fff",
      }}
    >
      <Popover.Body style={{ fontSize: "12px", color: "#435971", padding: "8px 12px" }}>
        Existing records remain unaffected; new records will follow the updated points system.
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Points System</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Points System</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-grow-1">
        {/* <div className="filter-card">
          <h6 className="filter-card-title">Reward Points</h6>
          <p className="mb-0" style={{ fontSize: "0.88rem", color: "#64748b" }}>
            Configure points earned for each activity. Existing records remain unaffected; new records follow the updated points.
          </p>
        </div> */}

        <div className="card icard sticky-table-card">
          <StickyTable refreshDeps={[data, loading]}>
            <table className="table table-striped itable sticky-action-col">
              <thead>
                <tr>
                  <th style={{ width: "8%" }}>Sl. No.</th>
                  <th>Action / Activity</th>
                  <th>Description</th>
                  <th className="text-center" style={{ width: "15%" }}>
                    Points Earned{" "}
                    <OverlayTrigger
                      trigger="click"
                      rootClose
                      placement="top"
                      overlay={popover}
                    >
                      <i
                        className="bx bx-info-circle ms-1"
                        style={{ cursor: "pointer", color: "#696cff" }}
                      ></i>
                    </OverlayTrigger>
                  </th>
                  {hasPermission("points-system-edit") && (
                    <th className="text-end" style={{ width: "10%" }}>
                      Action
                    </th>
                  )}
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader
                    loading={loading}
                    colspan={hasPermission("points-system-edit") ? "5" : "4"}
                  />
                ) : data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.action}</td>
                      <td>{item.description}</td>
                      <td className="text-center">{item.points}</td>
                      {hasPermission("points-system-edit") && (
                        <td style={{ textAlign: "right" }}>
                          <button
                            className="badge bg-label-success me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Edit points"
                            data-bs-original-title="Edit points"
                            onClick={() => openEditModal(item)}
                          >
                            <i className="bx bx-pencil"></i>
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <NoDataFound
                    colspan={hasPermission("points-system-edit") ? "5" : "4"}
                    message="No Data Found"
                  />
                )}
              </tbody>
            </table>
          </StickyTable>
        </div>
      </div>

      <Modal
        show={editModal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setEditModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            {editData?.action || "Edit Points"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="points">
                    Points Earned<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="form-control"
                    id="points"
                    value={editData?.points ?? ""}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setError("");
                      setEditData({ ...editData, points: value });
                    }}
                    placeholder="Enter points"
                  />
                  {error && <span className="text-danger">{error}</span>}
                  <small className="text-muted d-block mt-1">
                    Note: Existing records remain unaffected; new records will follow the updated points system.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-success isubmit_button"
            disabled={btnDisabled}
            onClick={updatePoints}
          >
            Update
          </button>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            onClick={() => setEditModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <div className="content-backdrop fade"></div>
    </div>
  );
};

export default PointsSystem;
